import React from "react";
import { Link } from "react-router-dom";
import { config } from "../../pages/config";

const Cta = () => {
    return (
        <section class="cta-banner">
            <div class="cta-banner__content">
                <h2>Ready to Find Your<br /><em>Timeless Treasure?</em></h2>
                <p>Book a personalized consultation with Maa vaishno jewellers and let us help you find or create the perfect piece for every special occasion.</p>
                <Link
                    to={`${config.appUrl}contact-us`}
                    className="btn btn--primary"
                >Get Started</Link>
            </div>
        </section>
    );
};

export default Cta;
